module.exports = __webpack_public_path__ + "img/botswana.981bd3be.svg";